export default __webpack_public_path__ + "static/media/slider_image_01-lg@2x.cae96a4b.webp";